import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const customFieldsApi = createApi({
  reducerPath: "customFieldsApi",
  baseQuery,
  tagTypes: ['CustomFieldDefinitions', 'CustomFieldValues'],
  endpoints: (builder) => ({
    // Field Definitions endpoints
    getFieldDefinitions: builder.query({
      query: (maintenanceId) => `custom-field-definitions/maintenance/${maintenanceId}`,
      providesTags: (result, error, maintenanceId) => [
        { type: 'CustomFieldDefinitions', id: maintenanceId }
      ],
    }),
    createFieldDefinition: builder.mutation({
      query: ({ maintenanceId, fieldData }) => ({
        url: `custom-field-definitions/maintenance/${maintenanceId}`,
        method: "POST",
        body: fieldData,
      }),
      invalidatesTags: (result, error, { maintenanceId }) => [
        { type: 'CustomFieldDefinitions', id: maintenanceId }
      ],
    }),
    updateFieldDefinition: builder.mutation({
      query: ({ id, fieldData }) => ({
        url: `custom-field-definitions/${id}`,
        method: "PUT",
        body: fieldData,
      }),
      invalidatesTags: (result, error, { maintenanceId }) => [
        { type: 'CustomFieldDefinitions', id: maintenanceId }
      ],
    }),
    reorderFieldDefinition: builder.mutation({
      query: ({ id, display_order }) => ({
        url: `custom-field-definitions/${id}/reorder`,
        method: "PATCH",
        body: { display_order },
      }),
      invalidatesTags: (result, error, { maintenanceId }) => [
        { type: 'CustomFieldDefinitions', id: maintenanceId }
      ],
    }),
    deleteFieldDefinition: builder.mutation({
      query: (id) => ({
        url: `custom-field-definitions/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, maintenanceId) => [
        { type: 'CustomFieldDefinitions', id: maintenanceId }
      ],
    }),

    // Field Values endpoints
    getFieldValues: builder.query({
      query: (machineMaintenanceId) => `custom-field-values/machine-maintenance/${machineMaintenanceId}`,
      providesTags: (result, error, machineMaintenanceId) => [
        { type: 'CustomFieldValues', id: machineMaintenanceId }
      ],
    }),
    saveFieldValues: builder.mutation({
      query: ({ machineMaintenanceId, values }) => ({
        url: `custom-field-values/machine-maintenance/${machineMaintenanceId}`,
        method: "POST",
        body: { values },
      }),
      invalidatesTags: (result, error, { machineMaintenanceId }) => [
        { type: 'CustomFieldValues', id: machineMaintenanceId }
      ],
    }),
  }),
});

export const {
  useGetFieldDefinitionsQuery,
  useCreateFieldDefinitionMutation,
  useUpdateFieldDefinitionMutation,
  useReorderFieldDefinitionMutation,
  useDeleteFieldDefinitionMutation,
  useGetFieldValuesQuery,
  useSaveFieldValuesMutation,
} = customFieldsApi;
